import { Component, Input } from '@angular/core';
import { IAnnotation } from '@ahryman40k/ts-fhir-types/lib/R4';
import { AbstractDetailsComponent } from '../../../../../shared/abstracts/details/abstract-details/abstract-details.component';

@Component({
  selector: 'inc-alert-comment-details',
  templateUrl: './alert-comment-details.component.html',
  styleUrls: ['./alert-comment-details.component.scss'],
})
export class AlertCommentDetailsComponent extends AbstractDetailsComponent<IAnnotation> {
  @Input() user: any;

  constructor() { super(); }

  more(): void { this.callMore.emit(this.inData); }

  checkForPermission(): boolean {
    if (this.user && this.user.uid && this.inData && this.inData.authorReference && this.inData.authorReference.reference) {
      return this.user.uid === this.inData.authorReference.reference;
    }
  }
}
